/** @jsx jsx */
import { jsx } from "@emotion/react";
import { FC, useEffect, useState } from "react";
import { _window } from "../../../../../globalConsts";
import {
  invokeRNMessage,
  INVOKE_SHOW_NOTIFICATIONS,
} from "../../../../../utils/nativeUtils";
import {
  NotificationsIconContainer,
  NotificationsListItem,
  StyledNotificationIndicator,
  StyledNotificationsIcon,
} from "./styles";

export type Props = { isOpen: boolean };

const NativeNotificationIcon: FC<Props> = ({ isOpen }) => {
  const [count, setCount] = useState<number | undefined>(undefined);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleCountUpdate = (event: any) => {
    if (event.detail !== undefined && event.detail !== null)
      setCount(Number(event.detail));
  };

  useEffect(() => {
    window.addEventListener("notificationsChanged", handleCountUpdate);
    return (): void => {
      window.removeEventListener("notificationsChanged", handleCountUpdate);
    };
  }, []);

  const handleClick = () => {
    invokeRNMessage(INVOKE_SHOW_NOTIFICATIONS, window.location.href);
  };

  const notifCount = count === undefined ? _window.notificationsCount : count;

  return (
    <NotificationsListItem>
      <NotificationsIconContainer id="tour-notifications" onClick={handleClick}>
        <StyledNotificationsIcon isActive={isOpen} />
        <StyledNotificationIndicator notificationCount={notifCount}>
          {notifCount}
        </StyledNotificationIndicator>
      </NotificationsIconContainer>
    </NotificationsListItem>
  );
};

export default NativeNotificationIcon;
export type NativeNotificationIconProps = Props;
